var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.187 19.4674H21.2204V3.21057H12.187V19.4674Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.76 11.3391C12.76 8.04093 14.3019 5.10353 16.7031 3.21064C14.9469 1.82609 12.7313 1.00012 10.323 1.00012C4.62163 1.00012 0 5.62909 0 11.3391C0 17.049 4.62163 21.678 10.323 21.678C12.7313 21.678 14.9469 20.852 16.7031 19.4675C14.3019 17.5743 12.76 14.6372 12.76 11.3391Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0839 17.7456V17.3444H32.9792L32.859 17.6204L32.7386 17.3444H32.6339V17.7456H32.7076V17.4429L32.8206 17.704H32.8972L33.0102 17.4423V17.7456H33.0839ZM32.4211 17.7456V17.4128H32.5554V17.345H32.2141V17.4128H32.348V17.7456H32.4211ZM33.4062 11.3389C33.4062 17.0489 28.7843 21.6779 23.0832 21.6779C20.6749 21.6779 18.459 20.8519 16.7031 19.4673C19.1043 17.5745 20.6463 14.637 20.6463 11.3389C20.6463 8.0411 19.1043 5.10369 16.7031 3.21052C18.459 1.82597 20.6749 1 23.0832 1C28.7843 1 33.4062 5.62897 33.4062 11.3389Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardCard);
export default __webpack_public_path__ + "static/media/mastercard-card.8477cfa35746571e82ad67e2b16508c4.svg";
export { ForwardRef as ReactComponent };